export const SET_GRID_CONFIG = 'SET_GRID_CONFIG'

export function setGridConfig(payload) {
	return {
		type: SET_GRID_CONFIG,
		payload,
	}
}

export default function reducer(state = {}, action) {
	switch (action.type) {
		case SET_GRID_CONFIG:
			return Object.assign({}, state, action.payload)
		default:
			return state
	}
}
